import React from "react";

const NaboraMonthSector = ({ slug, data }) => {
  const defaultData = {
    heading: "HYBRID ONLINE - Drives OFFLINE EXHIBITIONS 🔥",
    quarter: "Q3: 2026",
    period: "Jul 1 — Jul 31",
    location: "Live in your neighbourhood",
    cta: "Explore The Exhibition",
    sectors: [
      {
        emoji: "🥫",
        title: "FMCG & Food",
        subtitle: "120+ Merchants Participating",
        subtitleColor: "text-cyan-400",
      },
      {
        emoji: "👗",
        title: "Fashion & Lifestyle",
        subtitle: "90+ Brands Participating",
        subtitleColor: "text-pink-400",
      },
      {
        emoji: "🧺",
        title: "Local Crafts & Handmade",
        subtitle: "75+ Artisans & Makers Participating",
        subtitleColor: "text-emerald-400",
      },
    ],
  };

  const exhibition = data || defaultData;

  return (
    <div className="py-4 px-6 bg-[#0a0a0f] border-t border-b border-white/10">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-slate-900 to-violet-950 p-1 rounded-[2.5rem]">
          <div className="bg-slate-950 rounded-[2rem] p-4 text-center">
            <div className="uppercase tracking-[4px] text-yellow-300 text-sm mb-3">
              {exhibition.heading}
            </div>

            <div className="text-xl lg:text-2xl font-bold tracking-tighter mb-6 text-white">
              {exhibition.quarter}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-6xl mx-auto">
              {exhibition.sectors.map((sector, index) => (
                <div
                  key={index}
                  className="bg-white/5 rounded-3xl p-6 flex items-center gap-4 hover:bg-white/10 transition-all"
                >
                  <span className="text-6xl">{sector.emoji}</span>

                  <div>
                    <div className="text-lg lg:text-xl font-semibold text-white">
                      {sector.title}
                    </div>

                    <div
                      className={`${sector.subtitleColor} text-sm lg:text-base`}
                    >
                      {sector.subtitle}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="w-full px-4 py-2 mt-6 bg-gradient-to-r from-fuchsia-500 to-violet-600 rounded-xl font-semibold text-sm lg:text-lg flex items-center justify-center gap-2 whitespace-nowrap hover:scale-105 transition-all active:scale-95 shadow-xl shadow-purple-500/50">
              <span>✨ {exhibition.cta}</span>
              <span className="text-xl shrink-0">→</span>
            </button>

            <div className="mt-4 text-sm text-slate-200 flex justify-center gap-4">
              <div>{exhibition.period}</div>
              <div>{exhibition.location}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NaboraMonthSector;
